import React, { useState, useEffect, useCallback } from 'react';
import PasswordPolicy from './PasswordPolicy';
import MfaPolicy from './MfaPolicy';
import SessionManagement from './SessionManagement';
import SsoConfiguration from './SsoConfiguration';

const AuthenticationTab = ({ scopeType, scopeId, canAccessSSO = true }) => {
  const [subTab, setSubTab] = useState('password-policy');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Redirect Teams users away from SSO if they try to access it directly
  useEffect(() => {
    if (subTab === 'sso' && !canAccessSSO) {
      setSubTab('password-policy');
    }
  }, [subTab, canAccessSSO]);

  const subTabs = [
    { id: 'password-policy', label: 'Password Policy' },
    { id: 'mfa-policy', label: 'Multi-Factor Authentication' },
    { id: 'session-management', label: 'Session Management' },
    ...(canAccessSSO ? [{ id: 'sso', label: 'Single Sign-On (SSO)' }] : [])
  ];

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: '24px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '8px', color: '#111827' }}>
          Authentication Settings
        </h2>
        <p style={{ color: '#6b7280', fontSize: '14px' }}>
          Configure authentication policies and methods for your {scopeType === 'Team' ? 'team' : 'organization'}.
        </p>
      </div>

      {/* Sub-tabs */}
      <div style={{ 
        borderBottom: '2px solid #e5e7eb',
        marginBottom: '24px',
        display: 'flex',
        gap: '8px'
      }}>
        {subTabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setSubTab(tab.id)}
            style={{
              padding: '12px 24px',
              border: 'none',
              borderBottom: subTab === tab.id ? '2px solid #3b82f6' : '2px solid transparent',
              background: 'transparent',
              color: subTab === tab.id ? '#3b82f6' : '#6b7280',
              fontWeight: subTab === tab.id ? 600 : 400,
              cursor: 'pointer',
              fontSize: '14px',
              marginBottom: '-2px',
              transition: 'all 0.2s'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Error display */}
      {error && (
        <div style={{
          padding: '12px 16px',
          backgroundColor: '#fef2f2',
          border: '1px solid #fecaca',
          borderRadius: '8px',
          color: '#991b1b',
          marginBottom: '16px'
        }}>
          {error}
        </div>
      )}

      {/* Sub-tab content */}
      {loading && (
        <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
          Loading...
        </div>
      )}

      {!loading && (
        <>
          {subTab === 'password-policy' && (
            <PasswordPolicy scopeType={scopeType} scopeId={scopeId} />
          )}
          {subTab === 'mfa-policy' && (
            <MfaPolicy scopeType={scopeType} scopeId={scopeId} />
          )}
          {subTab === 'session-management' && (
            <SessionManagement scopeType={scopeType} scopeId={scopeId} />
          )}
          {subTab === 'sso' && !canAccessSSO && (
            <div style={{ padding: 24, textAlign: 'center' }}>
              <h3 style={{ marginTop: 0, marginBottom: 12, color: '#dc2626' }}>Feature Not Available</h3>
              <p style={{ marginBottom: 20, color: '#6b7280' }}>
                This feature is only available in Enterprise tier.
              </p>
              <a 
                href="/pricing" 
                style={{
                  display: 'inline-block',
                  padding: '10px 20px',
                  backgroundColor: '#4c51bf',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '6px',
                  fontWeight: 600
                }}
              >
                Upgrade to Enterprise
              </a>
            </div>
          )}

          {subTab === 'sso' && canAccessSSO && (
            <SsoConfiguration scopeType={scopeType} scopeId={scopeId} />
          )}
        </>
      )}
    </div>
  );
};

export default AuthenticationTab;

